import { render, staticRenderFns } from "./RecentOpportunityReport.vue?vue&type=template&id=1f63a214"
import script from "./RecentOpportunityReport.vue?vue&type=script&lang=js"
export * from "./RecentOpportunityReport.vue?vue&type=script&lang=js"
import style0 from "./RecentOpportunityReport.vue?vue&type=style&index=0&id=1f63a214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports